import * as React from "react";
import TextField from "@mui/material/TextField";
import { Grid, Box, IconButton, InputAdornment } from "@mui/material";
import calendarGrayIco from "@assets/icons/common/calendar-gray-ico.svg";
import closeGrayIcon from "@assets/icons/common/closeGrayIcon.svg";
import styles from "./DateRangePicker.module.scss";
import { DateRangePicker, LocalizationProvider } from '@material-ui/pickers';
import AdapterDateFns from "@material-ui/pickers/adapter/date-fns";
import moment from "moment";

export default function BasicDateRangePicker(props: any) {
  const { valueDate, setValueDate, disableFuture } : any = props;
  const [isOpenDateRange, setIsOpenDateRange] = React.useState(false);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateRangePicker
                displayStaticWrapperAs="desktop"
                value={valueDate}
                open={isOpenDateRange}
                onOpen={() => setIsOpenDateRange(true)}
                onClose={()=>{
                  // handleChangeDate();
                  setIsOpenDateRange(false)
                }}
                onChange={([newStartDate, newEndDate]: [any, any]) => {
                  setValueDate([newStartDate, newEndDate]); 
                  if(moment(newEndDate as Date).format('L') === moment(newStartDate as Date).format('L')){
                    setIsOpenDateRange(false)
                  }                                   
                }}
                disableFuture={disableFuture}
                renderInput={({ inputProps}:any, endProps:any) => {
                  const startValue = inputProps.value;
                  delete inputProps.value
                  return (
                    <Grid
                      container
                      alignItems="center"
                      flexDirection='row'
                      className={styles.DateRangePicker}
                      
                    >
                      <Grid item style={{marginRight: "15px"}} onClick={() => setValueDate([null, null])}><img src={closeGrayIcon} style={{width:"15px"}}alt=""/></Grid>
                      <Grid item className={styles.TextFieldTime}>
                      <TextField
                        className={styles.btnCalendar}
                        inputProps={inputProps}
                        id="datePickerInput"
                        variant="standard"
                        label={
                        <div style={{width: "100%", display: "flex"}}>
                          <span style={{marginRight: "133px", fontSize: "14px",color: "#C6C4C4"}}>Từ ngày</span>
                          <span style={{fontSize: "14px",color: "#C6C4C4"}}>Đến ngày</span>
                        </div>
                          }
                        color="secondary"
                        fullWidth={true}
                        value={`${startValue}             -       ${endProps.inputProps.value}`}
                        InputProps={{
                          
                          className: "DatePickerInput",
                          endAdornment: (
                            <InputAdornment position="start">
                              <label htmlFor="datePickerInput">
                                <img src={calendarGrayIco} alt="" style={{ cursor:"pointer"}} onClick={() => setIsOpenDateRange(true)}/>
                              </label>
                            </InputAdornment>
                          ),
                          disableUnderline: true,
                        
                        }}
                      />
                      </Grid>
                      </Grid>
                )}}
              />
            </LocalizationProvider>
  );
}

